export default {
  SIGNATURES: {
    PENDING: 'PENDING',
    SIGNED: 'SIGNED',
  },
  TRADING_OFFER_OPERATION: {
    IDENTITY_DOCUMENT: 'IDENTITY_DOCUMENT',
    OWNERSHIP_CERTIFICATE: 'OWNERSHIP_CERTIFICATE',
    PAYMENT_JUSTIFICATION: 'PAYMENT_JUSTIFICATION',
    CONTRACT_OR_AGREEMENT: 'CONTRACT_OR_AGREEMENT',
    OTHER: 'OTRO',
  },
};
